export default function CustomLoadingScreen() {
  return (
    <div className='absolute inset-0 flex justify-center items-center  w-full h-full z-50 overflow-hidden opacity-75'>
      <div className='loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mt-12 mb-4'></div>
    </div>
  );
}
